import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import { useTranslation } from 'react-i18next';

const ProtectedRoute = ({ children, allowedRoles = [] }) => {
  const { isAuthenticated, getUserType, loading } = useAuth();
  const { t } = useTranslation();
  const location = useLocation();

  const userType = getUserType();
  const isAuth = isAuthenticated();

  console.log('ProtectedRoute: Checking access', { 
    isAuthenticated: isAuth, 
    userType, 
    allowedRoles, 
    loading,
    pathname: location.pathname 
  });

  // Show loading spinner while checking authentication
  if (loading) {
    console.log('ProtectedRoute: Showing loading spinner');
    return (
      <div className="min-h-screen bg-white flex items-center justify-center">
        <div className="text-tiffany text-2xl font-playfair animate-pulse">
          {t('common.loading')}
        </div>
      </div>
    );
  }

  // Redirect to home if not authenticated (since login is now modal)
  if (!isAuth) {
    console.log('ProtectedRoute: Not authenticated, redirecting to home');
    return <Navigate to="/" state={{ from: location }} replace />;
  }

  // Check role-based access if roles are specified
  if (allowedRoles.length > 0) {
    console.log('ProtectedRoute: Checking role access', { userType, allowedRoles, includes: allowedRoles.includes(userType) });
    if (!allowedRoles.includes(userType)) {
      console.log('ProtectedRoute: Role not allowed, redirecting');
      // Redirect to appropriate dashboard based on user type
     switch (userType) {
  case 'admin':
    return <Navigate to="/admin/dashboard" replace />;

  case 'doctor':
    return <Navigate to="/doctor/dashboard" replace />;

  case 'staff':
    return <Navigate to="/reception/dashboard" replace />;

  case 'patient':
  default:
    return <Navigate to="/patient/dashboard" replace />;
}
    }
  }

  console.log('ProtectedRoute: Access granted, rendering children');
  return children;
};

export default ProtectedRoute; 
